import React, { createContext, useEffect, useState } from 'react';
import { addValueToObject } from '../utils/objectUtils.js';
import { getGridColumnsString } from '../utils/index.js';

export const TableContext = createContext();

const TableProvider = ({ tableConfig, tableStructure, isDragable, dragHandle, children }) => {
    const [structure, setStructure] = useState(tableStructure);
    const [gridColumns, setGridColumns] = useState(getGridColumnsString(structure, isDragable));
    const [dragable, setDragable] = useState(isDragable);
    const [dragHandleComponent, setDragHandleComponent] = useState(dragHandle);
    const [globalState, replaceGlobalState] = useState({config: tableConfig});

    const setGlobalState = (key, value) => {
        const data = {...globalState};
        addValueToObject(data, key, value);
        replaceGlobalState(data);
    }

    const setGlobalStateBulk = (items) => {
        const data = {...globalState};
        for (const key in items) {
            addValueToObject(data, key, items[key]);
        }
        replaceGlobalState(data);
    }

    useEffect(()=>{
        setGlobalState('config', tableConfig);
    },[tableConfig]);

    useEffect(() => {
        setStructure(tableStructure);
    }, [tableStructure]);

    useEffect(() => {
        setDragable(isDragable);
    }, [isDragable]);

    useEffect(() => {
        setDragHandleComponent(dragHandle);
    }, [dragHandle]);

    useEffect(() => {
        setGridColumns(getGridColumnsString(structure, dragable));
    }, [structure, dragable]);

    return <TableContext.Provider value={{structure, dragable, dragHandle: dragHandleComponent, gridColumns, globalState, setGlobalState, setGlobalStateBulk}}>{children}</TableContext.Provider>
}

export const useTableContext = () => React.useContext(TableContext);

export default TableProvider;
export {TableProvider};